import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The components of the GPU particles collision and attractor nodes. They draw nothing of their own,
 * so the intent stays `pending`: the Node3D base mounts for `visible` and the workspace split, with
 * Godot's editor gizmo on it for every node, faint while unselected (ADR-0056).
 */
import { useMemo } from 'react';
import { centredAabb, cubeAabb } from '../../../../godot/math/aabb';
import { NodeAabb } from '../../../../r3f/components/NodeAabb';
import { PluginGizmo } from '../../../../r3f/gizmo/PluginGizmo';
import { invisibleBase } from '../../../../r3f/invisibleBase';
import { Node3D } from '../../../base/node3d/Component';
import { ATTRACTOR_COLOR, BoxVolumeGizmo, COLLISION_COLOR, SdfVolumeGizmo, SphereVolumeGizmo } from './Gizmo';
const colorOf = (kind) => (kind === 'collision' ? COLLISION_COLOR : ATTRACTOR_COLOR);
function volumeNode(aabbOf, drawGizmo) {
    return invisibleBase(function VolumeNode({ node, children }) {
        const properties = node.properties;
        const aabb = useMemo(() => aabbOf(properties), [properties]);
        return (_jsxs(Node3D, { node: node, children: [_jsx(NodeAabb, { aabb: aabb }), _jsx(PluginGizmo, { drawnFor: "every-node", children: drawGizmo(properties) }), children] }));
    });
}
export const boxVolumeNode = (kind) => volumeNode(({ size }) => centredAabb(size), ({ size }) => _jsx(BoxVolumeGizmo, { size: size, color: colorOf(kind) }));
export const sphereVolumeNode = (kind) => volumeNode(({ radius }) => cubeAabb(radius), ({ radius }) => _jsx(SphereVolumeGizmo, { radius: radius, color: colorOf(kind) }));
export const sdfVolumeNode = () => volumeNode(({ size }) => centredAabb(size), ({ size, resolution }) => _jsx(SdfVolumeGizmo, { size: size, resolution: resolution }));
//# sourceMappingURL=volumeNode.js.map